import React from 'react';
import Hero from '../components/Hero';
import Benefits from '../components/Benefits';
import Testimonials from '../components/Testimonials';
import Packages from '../components/Packages';
import Services from '../components/Services';
import FAQ from '../components/FAQ';
import ContactForm from '../components/ContactForm';

export default function Home() {
  return (
    <>
      <Hero />
      <Testimonials />
      <Benefits />
      <Packages />
      <Services />
      <FAQ />
      <ContactForm />
    </>
  );
}
